import { render, staticRenderFns } from "./Kurslarim.vue?vue&type=template&id=3fa639bc&"
import script from "./Kurslarim.vue?vue&type=script&lang=js&"
export * from "./Kurslarim.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports